<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 24 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.9471 1.85635C20.8901 0.659273 19.3996 0 17.75 0C15.7158 0 14.1846 1.17179 13.1117 2.47174L12.4941 3.05469C12.7386 3.43884 12.9183 3.73832 13.0332 3.95312C13.1481 4.16793 13.3128 4.51233 13.5273 4.98633L14.0687 4.18353C14.8928 2.99633 16.1271 1.79688 17.75 1.79688C20.0406 1.79688 21.7031 3.64833 21.7031 6.19922C21.7031 8.75011 20.0406 10.6016 17.75 10.6016C14.4754 10.6016 12.8674 5.95961 12.852 5.91401L12.8475 5.90112C12.7628 5.66016 10.7207 0 6.25 0C4.60038 0 3.10987 0.659273 2.0529 1.85635C1.05151 2.99054 0.5 4.53289 0.5 6.19922C0.5 7.86555 1.05151 9.4079 2.0529 10.5421C3.10987 11.7392 4.60038 12.3984 6.25 12.3984C8.30086 12.3984 9.82425 11.2561 10.8879 9.97486L11.416 9.29883C11.1671 8.95068 10.9874 8.66617 10.877 8.44531C10.7665 8.22445 10.6318 7.88005 10.4727 7.41211L9.93508 8.25462C9.12181 9.42771 7.8967 10.6016 6.25 10.6016C3.95939 10.6016 2.29688 8.75011 2.29688 6.19922C2.29688 3.64833 3.95939 1.79688 6.25 1.79688C9.41039 1.79688 11.0974 6.34589 11.1512 6.49395C11.2706 6.84578 13.2288 12.3984 17.75 12.3984C19.3996 12.3984 20.8901 11.7392 21.9471 10.5421C22.9485 9.4079 23.5 7.86555 23.5 6.19922C23.5 4.53289 22.9485 2.99054 21.9471 1.85635Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgInfinity',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>